import { AxiosError } from 'axios';
import { useAuth } from 'lib/auth';
import { useGet } from 'lib/swr-crud';
import { APIErrorResponse } from 'lib/utils';
import { useEffect } from 'react';
import {
  getPerks,
  getPerksUrl,
  redeemPerkReward,
  unlockPerk,
} from './api';
import {
  PerkResponse,
  PerksQueryParams,
  PerksResponse,
} from './types';

interface UsePerkOptions {
  params?: PerksQueryParams;
  isAllowToFetch?: boolean;
}

export const usePerks = ({
  params,
  isAllowToFetch = true,
}: UsePerkOptions = {}) => {
  const { session, loading } = useAuth();
  const userId = session?.user?.userId;

  const shouldFetch = !loading && isAllowToFetch;

  const { data, isLoading, error, mutate } = useGet<
    PerksResponse,
    AxiosError<APIErrorResponse>
  >(
    shouldFetch
      ? userId
        ? getPerksUrl(params) + userId
        : getPerksUrl(params)
      : null,
    async () => await getPerks(params),
  );

  useEffect(() => {
    mutate();
  }, [session?.user?.userId, mutate]);

  const total: number = data?.meta?.total ?? 0;

  const _unlockPerk = async (
    perkId: number,
  ): Promise<PerkResponse> => {
    return await unlockPerk(perkId);
  };

  const redeemReward = async (perkRewardId: number, code: string) => {
    return await redeemPerkReward(perkRewardId, code);
  };

  return {
    perks: data?.data ?? [],
    total,
    isLoading,
    error,
    session,
    mutate,
    unlockPerk: _unlockPerk,
    redeemReward,
  };
};
